// extracted by mini-css-extract-plugin
export default {"component":"Bleed_component__6pWOI"};